import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Iconify from '../../../components/iconify';
import GameForm from './GameForm';
import { MenuItem } from '@mui/material';

export default function CreateAndUpdateModal({ selectedGame }) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {selectedGame ? (
          <MenuItem onClick={handleClickOpen}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>
      ) : (
        <Button onClick={handleClickOpen} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
          New Game
        </Button>
      )}
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">{selectedGame ? 'Update Game' : 'Add New Game'}</DialogTitle>
        <DialogContent>
          <GameForm handleClose={handleClose} selectedGame={selectedGame} />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Skip Now
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
